import {
    SEARCH_NEWS_RECEIVE_DATA,
    SEARCH_NEWS_REQUEST_DATA,
    SEARCH_NEWS_REQUEST_DATA_FAILED
} from "../actions/search-news-actions";

const initialState = {
    data: {
        value: [],
        page: 0,
        size: 0
    },
    isLoading: false,
    error: null
};

export default function searchNewsReducer(state = initialState, action) {
    switch (action.type) {
        case SEARCH_NEWS_REQUEST_DATA:
            return { ...state, isLoading: true };
        case SEARCH_NEWS_RECEIVE_DATA:
            return {
                ...state,
                isLoading: false,
                data: {
                    value: action.payload.value || [],
                    page: action.payload.page || 0,
                    size: action.payload.size || 0,
                    totalCount: action.payload.totalCount || 0,
                    totalPages: action.payload.totalPages || 0
                }
            };
        case SEARCH_NEWS_REQUEST_DATA_FAILED:
            return { ...state, isLoading: false, error: action.payload };
        default:
            return state;
    }
}
